import React from 'react'
import PropTypes from 'prop-types'
import Image from '../utils/StyledImage'
import Link from '../utils/Link'
import FeaturedLabel from '../utils/FeaturedLabel'
import { isFeatured } from '../utils/Article'
import CoveredImage from '../utils/CoveredImage'

const BaseImageBox = props => {
  const {
    box: {
      featuredType,
      image,
      link,
      title
    },
    className,
    children,
    imageClass,
    featuredClass,
    imageComponent: ImageComponent
  } = props

  return (
    <Link href={link} className={className}>
      <div className='image-column'>
        <ImageComponent src={image} alt={title} className={imageClass}/>
        {
          isFeatured(featuredType) &&
          <FeaturedLabel title={featuredType} featuredClass={featuredClass}/>
        }
      </div>
      <div className='title-column'>
        {children}
      </div>
    </Link>
  )
}

BaseImageBox.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  imageClass: PropTypes.string,
  imageComponent: PropTypes.func,
  box: PropTypes.object.isRequired
}

const ImageBox = props => <BaseImageBox {...props} imageComponent={Image}/>

const CoveredImageBox = props => <BaseImageBox {...props} imageComponent={CoveredImage}/>

export {
  ImageBox,
  CoveredImageBox
}
